import * as React from 'react';
import type { SVGProps } from 'react';
import type { IconProps, ForwardedIconComponent } from './types';
const CenterFilled = (React.forwardRef<SVGSVGElement, SVGProps<SVGSVGElement> & IconProps>(function CenterFilled({
  title,
  titleId,
  size = '1em',
  ...props
}, ref) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" ref={ref} aria-labelledby={titleId} {...props}>
        {title ? <title id={titleId}>{title}</title> : null}
        <path fillRule="evenodd" clipRule="evenodd" d="M13.5 0h-3v3.125A9.007 9.007 0 0 0 3.124 10.5H0v3h3.124a9.007 9.007 0 0 0 7.376 7.375V24h3v-3.125a9.007 9.007 0 0 0 7.376-7.375H24v-3h-3.124A9.007 9.007 0 0 0 13.5 3.125V0Zm-3.22 13.79c-1-.98-1.06-2.61-.04-3.59.98-.94 2.54-.94 3.52 0 1.02.97.96 2.6-.04 3.59-.95.94-2.49.94-3.44 0Z" fill="currentColor" />
      </svg>;
}) as ForwardedIconComponent);
export default CenterFilled;